export const LtlFreightTrackingEvents = {
  BOOKING_SAVE_DRAFT: 'LTL_FREIGHT_BOOKING_SAVE_DRAFT',
  BOOKING_BOOK: 'LTL_FREIGHT_BOOKING_BOOK',
  BOOKING_DELETE: 'LTL_FREIGHT_BOOKING_DELETE',
  BOOKING_VOID: 'LTL_FREIGHT_BOOKING_VOID',
  BOOKING_CLOSE_WITHOUT_BOOKING: 'LTL_FREIGHT_BOOKING_CLOSE_WITHOUT_BOOKING',
  BOOKING_FORM_OPENED: 'LTL_FREIGHT_BOOKING_FORM_OPENED',
  CALC_DENSITY_CLICKED: 'LTL_FREIGHT_CALC_DENSITY_CLICKED',
  RATE_ERROR_SHOWN: 'LTL_FREIGHT_RATE_ERROR_SHOWN',
  ADD_SHIP_FROM: 'LTL_FREIGHT_ADD_SHIP_FROM',
  EXISTING_CUSTOMER_USED: 'LTL_FREIGHT_EXISTING_CUSTOMER_USED',
  EXISTING_COMMODITY_PRESET_USED: 'LTL_FREIGHT_EXISTING_COMMODITY_PRESET_USED',
  EXPORT_START: 'LTL_FREIGHT_EXPORT_START',
  PRINT_DOCUMENT: 'LTL_FREIGHT_PRINT_DOCUMENT',
  GRID_FILTER: 'LTL_FREIGHT_GRID_FILTER',
} as const;

export type LtlFreightBookingSource = 'from_order' | 'from_freight' | 'from_browse_rates';
